import { useState } from 'react';

const faqs = [
  {
    q: 'Who creates custom artwork near me?',
    a: "Deb's Art Designs creates custom, hand-crafted artwork designed around each client's vision. The studio focuses on original pieces that reflect personal style, offering a unique alternative to mass-produced décor.",
  },
  {
    q: 'How much does custom artwork cost?',
    a: 'Pricing varies based on size, complexity, and design requirements. Each piece is custom, so quotes are provided after discussing the project details and creative direction.',
  },
  {
    q: 'How long does custom artwork take?',
    a: 'Timelines depend on the scope and detail of the artwork. Each piece is created by hand, so completion time reflects the level of customization and artistic work involved.',
  },
  {
    q: "What types of custom artwork does Deb's Art Designs create?",
    a: "The studio creates a range of original works including commissioned pieces, decorative art, storybook fantasy scenes, and fully custom creations tailored to your space and vision.",
  },
  {
    q: 'How do I get started with a custom art project?',
    a: "Simply reach out through the contact form. Share your idea, inspiration, or the space you have in mind — and we'll take it from there. The process is collaborative and built entirely around you.",
  },
];

const FAQSection = () => {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full bg-[#FAF7F3] py-36 px-6 md:px-12 lg:px-20">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-24">
          <div>
            <div className="flex items-center gap-5 mb-10">
              <div className="w-16 h-px bg-[#C9A96E]/50"></div>
              <span className="text-[#C9A96E]/65 uppercase tracking-[0.5em] text-[9px] font-light">Questions</span>
            </div>
            <h2 className="font-serif text-[#1A1612]/85 leading-[0.9] tracking-[-0.01em]" style={{ fontSize: 'clamp(3rem, 5vw, 4.5rem)', fontWeight: 300 }}>
              Frequently<br />
              <em className="italic text-[#C9A96E]" style={{ fontWeight: 300 }}>Asked</em>
            </h2>
          </div>
          <p className="text-[#1A1612]/35 text-xs leading-[2.2] max-w-[220px] tracking-[0.06em] font-light">
            Everything you need to know about commissioning original artwork.
          </p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col">
          {faqs.map((faq, i) => (
            <div key={i} className="border-t border-[#1A1612]/8 last:border-b last:border-[#1A1612]/8">
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-start justify-between gap-8 py-9 text-left cursor-pointer group"
              >
                <h3
                  className={`font-serif leading-snug transition-colors duration-400 ${open === i ? 'text-[#C9A96E]' : 'text-[#1A1612]/65 group-hover:text-[#1A1612]/85'}`}
                  style={{ fontSize: 'clamp(1rem, 2vw, 1.4rem)', fontWeight: 300 }}
                >
                  {faq.q}
                </h3>
                <div className={`w-7 h-7 flex items-center justify-center shrink-0 border transition-all duration-500 mt-0.5 ${open === i ? 'border-[#C9A96E]/50 text-[#C9A96E] rotate-45' : 'border-[#1A1612]/12 text-[#1A1612]/30 group-hover:border-[#C9A96E]/30 group-hover:text-[#C9A96E]/60'}`}>
                  <i className="ri-add-line text-xs"></i>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-500 ${open === i ? 'max-h-48 pb-9' : 'max-h-0'}`}>
                <p className="text-[#1A1612]/45 text-sm leading-[2.1] tracking-[0.04em] font-light pr-16">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
